const index={
    state:{
        data:{
            helpCount:0, // 困人事件
            maintenanceCount:0,
            repairsCount:0,
            tiringCount:0, // 求救事件
            // otherCount:0, // 其他sim卡私有
            // aliyunCount:0,// 阿里云物联卡
            // automationCount:0, // 自动化联通
            // networkCount:0, // 网络sim卡数量
            // ExpireCount:0,// sim卡快过期状态数量
            onlineCount: 0, // 在线数量
            faultCount: 0, // 当前故障数量
            count: 0, // 总数量
            maintainCount: 2, // 维保数量
            offlineCount: 0,  // 离线数量
            f_terminalCount: 0,  //
            t_terminalCount: 0,
            wcr_terminalCount: 1,
            u_terminalCount: 1,
            e_terminalCount: 1,
            todayNewLiftCount: 0,
            todayNewFaultCount: 0,
            threeNewLift: [],
            faultMonthData: [],
            // maintainMonthData: []
        }
    },
    getter:{

    },
    mutations:{
        setIndex(state,data){
            if (data){
                Object.keys(data).forEach(key=>{
                        state.data[key] = data[key];
                })
            }
            else{
                Object.keys(state.data).forEach(key=>{
                    state.data[key]=0;
                })
            }
            state.data.maintenanceCount=10
            state.data.repairsCount=20
        },
        updateIndex(state,data){
            switch (data.type) {
                case "addF":
                    state.data.todayNewFaultCount++;
                    state.data.faultCount++;
                    state.data.faultMonthData[new Date().getMonth()]++;
                    break;
                case "delF":
                    state.data.todayNewFaultCount = state.data.todayNewFaultCount <= 0 ? 0 : state.data.todayNewFaultCount--;
                    state.data.faultCount = state.data.faultCount <= 0 ? 0 : state.data.faultCount--;
                    state.data.faultMonthData[new Date().getMonth()]++;
                    break;
                case "addL":
                    state.data.todayNewLiftCount++;
                    break;
                case "delL":
                    state.data.todayNewLiftCount--;
                    break;
                case "addT":
                    break;
                case "onoff": // 在线或离线
                    if (data.status == 'offline') {
                        state.data.onlineCount = state.data.onlineCount != 0 ? state.data.onlineCount-- : 0
                        state.data.offlineCount++;
                    } else {
                        state.data.offlineCount = state.data.offlineCount != 0 ? state.data.offlineCount-- : 0
                        state.data.onlineCount++
                    }
                    break;
            }
        }
    }
}
export default index;